import WidgetTypeCard, { Props } from './WidgetTypeCard';
import WidgetTypeCardContainer from './WidgetTypeCard.container';

export default WidgetTypeCardContainer(WidgetTypeCard);
export type Props = Props;
